import Vue from "vue";
import Vuex from "vuex";

import { Api } from "@/core/api.js";
const api = new Api();

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== "production";

export default new Vuex.Store({
  state: {
    language: localStorage.language ? localStorage.language : "cat",
    languages: [],
    app_url: "http://localhost:8080",
    table_relatioship: false,
    countries: [],
    how_meet: [],
    contact_type: {},
    category_type: {},
    alergy: {},
    campus_type: {},
    event_type: "",
    event_color: "",
    event_edition: "",
    redirect_page: "",
    shirt_size: {},
    redsys_params: {},
    join_campus: {},
    nike_weeks: {},
    promotional_code: {},
    campus_type_pga: {},
    discounts: {},
    services: {},
    diets: {}
  },
  modules: {},
  strict: debug,
  mutations: {
    setLanguage(state, value) {
      for (var k in this.languages) {
        if (this.languages[k].name == value) this.languages[k].selected = true;
        else this.languages[k].selected = false;
      }
      state.language = value;
      localStorage.language = value;
    },

    setTables(state, tables) {
      state.table_relatioship = true;

      if (typeof tables["country"] !== "undefined") {
        state.countries = tables["country"];
      }

      if (typeof tables["language"] !== "undefined") {
        state.languages = tables["language"];
      }

      if (typeof tables["how_meet"] !== "undefined") {
        state.how_meet = tables["how_meet"];
      }

      if (typeof tables["contact_type"] !== "undefined") {
        state.contact_type = tables["contact_type"];
      }

      if (typeof tables["category_type"] !== "undefined") {
        state.category_type = tables["category_type"];
      }

      if (typeof tables["event_color"] !== "undefined") {
        state.event_color = tables["event_color"];
      }

      if (typeof tables["event_edition"] !== "undefined") {
        state.event_edition = tables["event_edition"];
      }

      if (typeof tables["event_type"] !== "undefined") {
        state.event_type = tables["event_type"];
      }

      if (typeof tables["alergy"] !== "undefined") {
        state.alergy = tables["alergy"];
      }

      // nike
      if (typeof tables["campus_type"] !== "undefined") {
        let campus_types = tables["campus_type"];
        let result = {};
        for (let i in campus_types) {
          // validate if not exists
          if (!result.hasOwnProperty(campus_types[i].type)) {
            // create type in campus types
            result[campus_types[i].type] = {};
            // set checked to false
            result[campus_types[i].type].checked = false;
            // create object weeks
            result[campus_types[i].type].weeks = {};
          }
          // add editions
          result[campus_types[i].type]["weeks"][i] = {
            name:
              moment(campus_types[i].start_date).format("DD/MM/YYYY") +
              " - " +
              moment(campus_types[i].end_date).format("DD/MM/YYYY"),
            id: campus_types[i].id,
            first_date: moment(campus_types[i].start_date).format("DD/MM/YYYY"),
            last_date: moment(campus_types[i].end_date).format("DD/MM/YYYY")
          };
          state.nike_weeks[campus_types[i].id] = {
            id: campus_types[i].id,
            first_date: moment(campus_types[i].start_date).format("DD/MM/YYYY"),
            last_date: moment(campus_types[i].end_date).format("DD/MM/YYYY")
          };
        }
        state.campus_type = result;
      }

      // pga
      if (typeof tables["campus_type"] !== "undefined") {
        state.campus_type_pga = tables["campus_type"];
      }

      if (typeof tables["shirt_size"] !== "undefined") {
        state.shirt_size = tables["shirt_size"];
      }

      if (typeof tables["join_campus"] !== "undefined") {
        state.join_campus = tables["join_campus"];
      }

      if (typeof tables["discounts"] !== "undefined") {
        state.discounts = tables["discounts"];
      }

      if (typeof tables["services"] !== "undefined") {
        state.services = tables["services"];
      }

      if (typeof tables["diet"] !== "undefined") {
        state.diet = tables["diet"];
      }
    },

    setRedirectPage(state, value) {
      state.redirect_page = value;
    },

    setRedsysParams(state, value) {
      state.redsys_params = value;
    },

    setPromotionalCode(state, value) {
      state.promotional_code = value;
    }
  },
  actions: {
    getInscriptionsInfo: ({ commit }, params) => {
      return api
        .get("inscripcions/" + params.event_id)
        .then(function(response) {
          return commit("setTables", response.data);
        });
    },

    joinTournament: ({ commit }, params) => {
      return api
        .post("form/" + params.event_id + "/save", params)
        .then(function(response) {
          return commit("setRedirectPage", response.data);
        });
    },

    getCampusInfo: ({ commit }, params) => {
      return api
        .get("inscripcions/" + params.event_id + "/1")
        .then(function(response) {
          if (response.status) {
            commit("setTables", response.data);
          }
          return response;
        });
    },

    joinNikeCampus: ({ commit }, params) => {
      return api
        .post("form/" + params.event_id + "/join-nike-campus", params)
        .then(function(response) {
          return commit("setRedsysParams", response.data);
        });
    },

    joinNikeCampusBCN: ({ commit }, params) => {
      return api
        .post("form/" + params.event_id + "/join-nike-campus-bcn", params)
        .then(function(response) {
          return commit("setRedsysParams", response.data);
        });
    },

    joinAitana: ({ commit }, params) => {
      return api
        .post("form/" + params.event_id + "/join-aitana", params)
        .then(function(response) {
          return commit("setRedsysParams", response.data);
        });
    },

    joinPGACampus: ({ commit }, params) => {
      return api
        .post("form/" + params.campus_id + "/join-pga-campus", params)
        .then(function(response) {
          return commit("setRedsysParams", response.data);
        });
    },

    joinMundoDeportivo: ({ commit }, params) => {
      return api
        .post("form/" + params.event_id + "/join-mundodeportivo", params)
        .then(function(response) {
          return commit("setRedsysParams", response.data);
        });
    },

    checkDiscount: ({ commit }, params) => {
      return api.post("form/discount/check", params).then(function(response) {
        return commit("setPromotionalCode", response);
      });
    }
  },

  getters: {
    getLanguages: (state, getter, rootState) => {
      return state.languages;
    },

    getCountries: (state, getters, rootState) => {
      return state.countries;
    },

    getHowMeet: (state, getter, rootState) => {
      return state.how_meet;
    },

    getContactType: (state, getter, rootState) => {
      return state.contact_type;
    },

    getCategoryType: (state, getter, rootState) => {
      return state.category_type;
    },

    getEventColor: (state, getter, rootState) => {
      return state.event_color;
    },

    getEventType: (state, getter, rootState) => {
      return state.event_type;
    },

    getEventEdition: (state, getter, rootState) => {
      return state.event_edition;
    },

    getRedirectPage: (state, getter, rootState) => {
      return state.redirect_page;
    },

    getAlergies: (state, getter, rootState) => {
      return state.alergy;
    },

    getCampusType: (state, getter, rootState) => {
      return state.campus_type;
    },

    getShirtSizes: (state, getter, rootState) => {
      return state.shirt_size;
    },

    getRedsysParams: (state, getter, rootState) => {
      return state.redsys_params;
    },

    getJoinCampus: (state, getter, rootState) => {
      return state.join_campus;
    },

    getNikeWeeks: (state, getter, rootState) => {
      return state.nike_weeks;
    },

    getPromotionalCode: (state, getter, rootState) => {
      return state.promotional_code;
    },

    getCampusTypePGA: (state, getter, rootState) => {
      return state.campus_type_pga;
    },

    getDiscounts: (state, getter, rootState) => {
      return state.discounts;
    },

    getServices: (state, getter, rootState) => {
      return state.services;
    },

    getDiets: (state, getter, rootState) => {
      return state.diet;
    }
  }
});
